import PerfilService from '@/services/PerfilService';

export const perfil = {
    namespaced: true,
    actions: {
        newPerfil(){
            return PerfilService.newPerfil();
        },
        getAllPerfil () {
            return PerfilService.getAllPerfil()
                .then(
                    response => {
                        return response;
                    },
                    error => {
                        console.error(error);
                    }
                );
        },
        getPerfil ({id}) {
            return PerfilService.getPerfil(id)
                .then(
                    response => {
                        return response;
                    },
                    error => {
                        console.error(error);
                    }
                );
        },
        postPerfil ({payload}) {
            return PerfilService.postPerfil(payload)
                .then(
                    response => {
                        return response;
                    },
                    error => {
                        console.error(error);
                    }
                );
        },
        postPerfilRetornar ({dispatch}, payload) {
            return PerfilService.postPerfilRetornar(payload)
                .then(
                    response => {
                        return response;
                    },
                    error => {
                        console.error(error);
                    }
                );
        },
        putPerfil ({dispatch}, payload) {
            return PerfilService.putPerfil(payload)
            .then(
                response => {
                    return response;
                },
                error => {
                    console.error(error);
                    return Promise.reject(new Error(error));
                }
            );
        },
        deletePerfil ({dispatch}, id) {
            return PerfilService.deletePerfil(id)
            .then(
                response => {
                    return response;
                },
                error => {
                    console.error(error);
                    return Promise.reject(new Error(error));
                }
            );
        },
    },
    state: {},
    mutations: {},
};
